import moment from 'moment';
import * as dateUtils from './dateUtils';
import * as validationUtils from './formValidationUtils';
import * as commonUtils from './commonUtils';
import _FormClass from '../containers/FormClass';
import { Select, Radio, Popover, Icon, Divider } from 'antd';

const
{ getDataType } = commonUtils,
Option = Select.Option;

export const
HELP_SUFFIX = '_help',
STATUS_SUFFIX = '_status',
IS_REQUIRED = '_required',
IS_ATTRIBUTE = '_attribute',
CHECK = 'CHECK',
CHECK_TRUE = 'CHECK_TRUE',
INPUT = 'INPUT',
SELECT = 'SELECT',
SELECT_MULTIPLE = 'SELECT_MULTIPLE',
RADIO = 'RADIO',
DATE_PICKER = 'DATE_PICKER';

export function FormClass(formName, FormComponent) {
    return _FormClass(formName, FormComponent);
};
export function handleFieldChange(serviceHandler, blurServiceHandler, value, config, form, fieldName, type, e) {
    switch (type) {
        case INPUT:
            serviceHandler(form, e.target.id, e.target.value);
            break;
        case SELECT:
            serviceHandler(form, fieldName, e);
            break;
        case SELECT_MULTIPLE:
            serviceHandler(form, fieldName, e);
            break;
        case DATE_PICKER:
            const val = e;
            serviceHandler(form, fieldName, dateUtils.unixSecondsToDateString(val), val);
            break;
        case CHECK_TRUE:
        case CHECK:
            serviceHandler(form, e.target.id, e.target.checked);
            break;
        case RADIO:
            serviceHandler(form, e.target.name, e.target.value);
            handleOnBlur(blurServiceHandler, fieldName, e.target.value, config);
            break;
        default:
            return 'unsupported type';
    }
}

export function handleOnBlur(serviceHandler, fieldName, fieldValue, config) {
    let fieldConfig = config.formItems[fieldName];
    let result = validationUtils.validateField(fieldName, fieldValue, fieldConfig);
    serviceHandler(config.parentKey, config.key, result);
}

function initStateHelper(type) {
    switch (type) {
        case DATE_PICKER: return undefined;
        case CHECK: return undefined;
        case CHECK_TRUE: return true;
        case SELECT_MULTIPLE: return [];
        default: return '';
    }
}

export function generateInitState(config) {
    let returnVal = {};
    Object.keys(config.formItems).map(key => {
	    returnVal[`${key}`] = initStateHelper(config.formItems[key].type);
	    returnVal[`${key}${HELP_SUFFIX}`] = '';
	    returnVal[`${key}${STATUS_SUFFIX}`] = '';
        config.formItems[key].attribute == true ?
	    returnVal[`${key}${IS_ATTRIBUTE}`] = true: null;
	    returnVal.id = undefined;
    });
    return returnVal;
}
export function generateInitAttributeState(config) {
    let returnVal = {};
    Object.keys(config.formItems).map(key => {
        config.formItems[key].attribute == true ?
	    returnVal[`${key}${IS_ATTRIBUTE}`] = true: null;
    });
    return returnVal;
}

export function removeByKey (myObj, deleteKey) {
	  return Object.keys(myObj)
	    .filter(key => key !== deleteKey)
	    .reduce((result, current) => {
	      result[current] = myObj[current];
	      return result;
	  }, {});
}

export function generateFormItem(fieldName, config, state, excludeValidation) {
    // if exclude validation is set then skip help and status
    const
    { formItems } = config,
    field = formItems[fieldName];

    let includeColon = true;

    if (field.hasOwnProperty('includeColon')){
        includeColon = field.includeColon;
    }

    if (excludeValidation) return {
        style: { margin: 0 },
        label: field.label,
        colon: includeColon,
        extra: field.extra ? field.extra : ''
    }
    else return {
        style: { margin: 2 },
        required: field.optional ? !field.optional : true,
        label: field.label,
        colon: includeColon,
        extra: field.extra ? field.extra : '',
        validateStatus: state ? state[`${fieldName}${STATUS_SUFFIX}`]: '',
        help: state ? state[`${fieldName}${HELP_SUFFIX}`]: ''
    };
}

function inputComponentTypeValueHelper(type, state, fieldName) {
    switch (type) {
        case DATE_PICKER: return state && state[fieldName]
            ? moment(state[fieldName])
            : undefined;

        case SELECT_MULTIPLE: return state && state[fieldName]
            ? state[fieldName]
            : [];

        default: return state && state[fieldName]
            ? state[fieldName]
            : '';
    }
}

export function generateInputComponent(fieldName, config, isEditable, state, changeServiceHandler, blurServiceHandler, excludeValidation, includeLabel) {
    let { key } = config,
    type        = config.formItems[fieldName].type,
    placeholder = config.formItems[fieldName].placeholder

    if (excludeValidation) return { id: fieldName, locale: 'en', name: fieldName, disabled: true };
    else {

        let returnVal = {
            id: fieldName,
            locale: 'en',
            style: { minWidth: 165, maxWidth: 400 },
            size: 'small',
            name: fieldName,
            disabled: !isEditable,
            placeholder: placeholder != undefined ? placeholder : '',
            onChange: e => handleFieldChange(changeServiceHandler, blurServiceHandler, state[fieldName], config, key, fieldName, type, e),
            value: inputComponentTypeValueHelper(type, state, fieldName)
        }

        if (type === CHECK || type === CHECK_TRUE)
            if (state) returnVal.checked = state[fieldName];

        if (type === DATE_PICKER) {
        	returnVal.placeHolder = 'Select Date';
        	returnVal.getCalendarContainer = trigger => trigger.parentNode;
        }

        if (type === SELECT) {
            returnVal.showSearch = true;
            returnVal.allowClear = true;
            returnVal.filterOption = true;
            returnVal.optionFilterProp = 'label';
            returnVal.labelInValue = includeLabel ? true : false;
            returnVal.getPopupContainer = trigger => trigger.parentNode;
        }

        return returnVal;
    }
}

function sortedArrayByKey(objectArray) {
    let returnArray = [];

    Object.keys(objectArray).forEach(key => returnArray.push(key));
    try { returnArray.sort((a, b) => a > b); }
    catch (error) {}

    return returnArray;
}

function sortedArrayByOrder(objectArray) {
    let sortedArray = [];

    for (let d in objectArray) sortedArray.push(objectArray[d]);
    try { sortedArray.sort((a, b) => a.order - b.order); }
    catch (error) {}

    return sortedArray;
}

function sortedArrayByName(objectArray) {
    let sortedArray = [];

    for (let d in objectArray) sortedArray.push(objectArray[d]);
    try { sortedArray.sort((a, b) => a.name.localeCompare(b.name)); }
    catch (error) {}

    return sortedArray;
}

function sortedArrayByNameSIDA(objectArray) {
    let sortedArray = [];

    for (let d in objectArray) sortedArray.push(objectArray[d]);
    try { sortedArray.sort((a, b) => {
        return (a.value + ' - ' + a.name).localeCompare(b.value + ' - ' + b.name)}); }
    catch (error) {}

    return sortedArray;
}

function sortedArrayByNameAOB(objectArray) {
    let sortedArray = [];

    for (let d in objectArray) sortedArray.push(objectArray[d]);
    try { sortedArray.sort((a, b) => {return (a.value + ' - ' + a.name).localeCompare(b.value + ' - ' + b.name)}); }
    catch (error) {}

    return sortedArray;
}

function sortedArrayByDescription(objectArray) {
    let sortedArray = [];

    for (let d in objectArray) sortedArray.push(objectArray[d]);
    try { sortedArray.sort((a, b) => a.description.localeCompare(b.description)); }
    catch (error) {}

    return sortedArray;
}

function sortedArrayByCode(objectArray) {
    let sortedArray = [];

    for (let d in objectArray) sortedArray.push(objectArray[d]);
    try { sortedArray.sort((a, b) => a.code.localeCompare(b.code)); }
    catch (error) {}

    return sortedArray;
}


// All this sorting should be refactored.
export function generateOptionFromCommonData(dataArray, startsWithPrefix, ignoreViewable) {
    if (dataArray && Object.keys(dataArray).length > 0) {
        const array = sortedArrayByName(dataArray);
        return array.map(data => {
            if ((startsWithPrefix && data.value.startsWith(startsWithPrefix) || !startsWithPrefix) && (data.viewable || ignoreViewable)) {
                const name = data.name;
                const value = data.value;
                return <Option key={value} value={value} label={name}>{name}</Option>;
            }
        });
    }
}

export function generateOptionFromCommonDataSIDA(dataArray, startsWithPrefix, ignoreViewable) {
    if (dataArray && Object.keys(dataArray).length > 0) {
        const array = sortedArrayByNameSIDA(dataArray);
        return array.map(data => {
            if ((startsWithPrefix && data.value.startsWith(startsWithPrefix) || !startsWithPrefix) && (data.viewable || ignoreViewable)) {
                const name = data.name;
                const value = data.value;
                return <Option key={value} value={value} label={value + ' - ' +  name}>{value} - {name}</Option>;
            }
        });
    }
}

export function generateOptionFromCommonDataAOB(dataArray, startsWithPrefix, ignoreViewable) {
    if (dataArray && Object.keys(dataArray).length > 0) {
        const array = sortedArrayByNameAOB(dataArray);
        console.log(dataArray);
        return array.map(data => {
            if ((startsWithPrefix && data.value.startsWith(startsWithPrefix) || !startsWithPrefix) && (data.viewable || ignoreViewable)) {
                const name = data.name;
                const value = data.value;
                return <Option key={value} value={value} label={value + ' - ' + name}>{value} - {name}</Option>;
            }
        });
    }
}

export function generateOptionFromCommonDataSortByOrder(dataArray, startsWithPrefix, ignoreViewable) {
    if (dataArray && Object.keys(dataArray).length > 0) {
        const array = sortedArrayByOrder(dataArray);
        return array.map(data => {
            if ((startsWithPrefix && data.value.startsWith(startsWithPrefix) || !startsWithPrefix) && (data.viewable || ignoreViewable)) {
                const name = data.name;
                const value = data.value;
                return <Option key={value} value={value} label={name}>{name}</Option>;
            }
        });
    }
}

export function generateRadioFromCommonData(dataArray) {
    if (dataArray && Object.keys(dataArray).length > 0) {
        const array = sortedArrayByName(dataArray);
        return array.map(data => {
            const name = data.name
            const value = data.value;
            return <Radio key={value} value={value} label={name}>{name}</Radio>;
        });
    }
}

// Passing in a Valid County Code will place it at the top if placement==1, bottom if placement==-1 and remove if placement==0
export function generateCountryOptionsFromCommonData(dataArray, cntrycd, placement) {
    if (cntrycd == null) {
        cntrycd = 'NONE';
    }
    if (placement == null) {
        placement = 1;
    }
    if (dataArray && Object.keys(dataArray).length > 0) {
        var final = [];
        if (cntrycd == 'NONE') {final = sortedArrayByDescription(dataArray)}
        else {
            var dArray = [];
            var cArray = [];
            var ccd = "";
            for (let c in dataArray ) {
                if (dataArray[c].code == cntrycd) {
                    ccd=dataArray[c].code; 
                    cArray.push(dataArray[c])
                } 
                else dArray.push(dataArray[c])
            }
            const sorted = sortedArrayByDescription(dArray);
            if      (ccd != "" && placement ==  1) {final = cArray.concat(sorted)}
            else if (ccd != "" && placement == -1) {final = sorted.concat(cArray)}
            else {final = sorted}
        }
        return final.map(key => {
            const name = key.description;
            return <Option key={key.code} value={key.code} label={name} disabled= {key.archived} >{name}</Option>;
        })
    }
}

// Removing USA Selection from Candidate Registration
export function generateCountryOptionsFromCommonDataWithoutUSA(dataArray, cntrycd, placement) {
    if (cntrycd == null) {
        cntrycd = 'NONE';
    }
    if (placement == null) {
        placement = 1;
    }
    if (dataArray && Object.keys(dataArray).length > 0) {
        var final = [];
        if (cntrycd == 'NONE') {final = sortedArrayByDescription(dataArray)}
        else {
            var dArray = [];
            var cArray = [];
            var ccd = "";
            for (let c in dataArray ) {
                if (dataArray[c].code == cntrycd) {
                    ccd=dataArray[c].code; 
                    cArray.push(dataArray[c])
                } 
                else dArray.push(dataArray[c])
            }
            const sorted = sortedArrayByDescription(dArray);
            if      (ccd != "" && placement ==  1) {final = cArray.concat(sorted)}
            else if (ccd != "" && placement == -1) {final = sorted.concat(cArray)}
            else {final = sorted}
        }
        return final.map(key => {
            if(key.code === 'USA' ){
                return
            }
            const name = key.description;
            return <Option key={key.code} value={key.code} label={name} disabled= {key.archived} >{name}</Option>;
        })
    }
}

export function generateCountryList(dataArray, cntrycd, placement) {
    if (cntrycd == null) {
        cntrycd = 'NONE';
    }
    if (placement == null) {
        placement = 1;
    }
    if (dataArray && Object.keys(dataArray).length > 0) {
        var final = [];
        if (cntrycd == 'NONE') {final = sortedArrayByDescription(dataArray)}
        else {
            var dArray = [];
            var cArray = [];
            var ccd = "";
            for (let c in dataArray ) {
                if (dataArray[c].code == cntrycd) {
                    ccd=dataArray[c].code; 
                    cArray.push(dataArray[c])
                } 
                else dArray.push(dataArray[c])
            }
            const sorted = sortedArrayByDescription(dArray);
            if      (ccd != "" && placement ==  1) {final = cArray.concat(sorted)}
            else if (ccd != "" && placement == -1) {final = sorted.concat(cArray)}
            else {final = sorted}
        }
        return final.map(key => {
            const name = key.description;
            return [key.code, key.description];
        })
    }
}

export function generateStateOptionsFromCommonData(dataArray, countryCode) {
    if (dataArray && countryCode) {
        if (dataArray[countryCode]) {
            let states = dataArray[countryCode].states;
            if (states) {
                states = sortedArrayByCode(states);
                return states.map(state => {
                    const name = state.description;
                    const value = state.code;
                    return <Option key={value} value={value} label={name}>{name}</Option>;
                })
            }
        }
    }
    return <Option key={0} value={'ZZZ'}>{'No States Found'}</Option>;
}

export function generateProviderOptionsByState(isCat4, stateCd, providerData, candidateProviders, activeOnly) {
    if (providerData) {
        var providers = [];
        if (isCat4) {
            if (stateCd) {
                if (activeOnly) {
                    for (var i in providerData[stateCd]){
                        if (providerData[stateCd][i].status == 'E') {
                            providers.push(providerData[stateCd][i]);
                        }
                    }
                } else {
                    providers = providerData[stateCd];
                }
            } else {
                for (var state in providerData) {
                    for (var i in providerData[state]) {
                        if (!activeOnly || providerData[state][i].status == 'E') {
                            providers.push(providerData[state][i]);
                        }
                    }
                }
            }
            if (providers && providers.length !== 0) {
                var cat4Providers = [];
                for (var prov in providers) {
                    if (providers[prov].cat4Eligible == 'Y')
                        if (!activeOnly || providers[prov].status == 'E') {
                            cat4Providers.push(providers[prov]);
                        }
                    }
                return cat4Providers.map(cat4Provider => {
                    const value = cat4Provider.id;
                    const name = cat4Provider.name != null
                        ? cat4Provider.name
                        : cat4Provider.schoolName;
                    var isDisabled = false;
                    for (var canProv in candidateProviders) {
                        if (candidateProviders[canProv] == cat4Provider.id) {
                            isDisabled = true;
                            break;
                        }
                    }
                    return <Option disabled={isDisabled} key={value} value={value} label={name}>{name}</Option>;
                })
            }
        } else if (stateCd) {
            providers = providerData[stateCd];
            if (providers) {
                return providers.filter(prov => (!activeOnly || prov.status == 'E')).map(provider => {
                    const value = provider.id;
                    const name = provider.name != null
                        ? provider.name
                        : provider.schoolName;
                    return <Option key={value} value={value} label={name}>{name}</Option>;
                })
            }
        } else {
            for (var state in providerData) {
                for (var i in providerData[state]) {
                    if (!activeOnly || providerData[state][i].status == 'E') {
                        providers.push(providerData[state][i]);
                    }
                }
            }
            if (providers && providers.length !== 0) {
                var cat4Providers = [];
                for (var prov in providers) {
                    if (!activeOnly || providers[prov].status == 'E') {
                        cat4Providers.push(providers[prov]);
                    }
                }
                return cat4Providers.map(cat4Provider => {
                    const value = cat4Provider.id;
                    const name = cat4Provider.name != null
                        ? cat4Provider.name
                        : cat4Provider.schoolName;
                    var isDisabled = false;
                    for (var canProv in candidateProviders) {
                        if (candidateProviders[canProv] == cat4Provider.id) {
                            isDisabled = true;
                            break;
                        }
                    }
                    return <Option disabled={isDisabled} key={value} value={value} label={name}>{name}</Option>;
                })
            }
        }
    }
}

export function getMonthOptions() {
    let months = [];
    for (let i = 1; i < 13; i++) {
        months.push(<Option key={i} value={i}>{i}</Option>);
    }
    return months;
}

export function getYearsOptions() {
    const year = moment().format('YYYY');
    const yearNum = parseInt(year);
    let years = [];
    for (let i = yearNum; i < (yearNum + 20); i++) {
        years.push(<Option key={i} value={i}>{i}</Option>);
    }
    return years;
}

export function formRedirect(path, params, method) {
    method = method || 'post';

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params)
        if (params.hasOwnProperty(key)) {
            var hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);
            form.appendChild(hiddenField);
        }

    document
        .body
        .appendChild(form);
    form.submit();
}

export function meetsRequirements(data, requirements, returnAsObject) {
    returnAsObject = !!returnAsObject;
    let results = [];

    for (let r in requirements) {
        let req = requirements[r](data);
        switch (getDataType(req)) {
            case 'Object':
                results.push(req);
                break;
            case 'String':
                results.push({ valid: false, help: req });
                break;
        }
    }

    for (let r in results)
        if (!results[r].valid)
            return returnAsObject
                ? results[r]
                : false;

    return returnAsObject
        ? VALID
        : true;
}

export function setMaxWidth(d) { return {...d, style: { width: '100%' }} };

export function generateLabelWithPopover(label, message, popOverProps={}){
    return (
        <React.Fragment>
            <span>
            {label}
            <IconPopoverForLabel
                noTitle= {popOverProps.noTitle || true}
                title={popOverProps.title || 'Help'}
                placement={popOverProps.placement || 'top'}
                header={label == 'FSDO, CMO, or IFO' ? '' : popOverProps.header || 'Need help?'}
                iconStyle={popOverProps.iconStyle || { fontSize: '13px', fontWeight: 'bold' }}
            >
                <div style={{ marginLeft: '10px' }}>{message}</div>
            </IconPopoverForLabel>
            </span>
        </React.Fragment>
    );

};

export function generateExtraMessageWithIcon(message, iconType){
        iconType = iconType?iconType:'info-circle';
    return(
        <React.Fragment>
            <span className='ss-extra-message'>
                <Icon type={iconType} style={{marginRight: '3px'}} /> {message}
            </span>
        </React.Fragment>
    );
};

class IconPopoverForLabel extends React.Component{
    constructor(props) { super(props); }
    render() {
        const { title, header, placement, children, noTitle, iconStyle } = this.props;
        return (
                <Popover placement={placement || 'top'} content={(
                    <div className='ss-utils-popover-div-outer'>
                        <div className='ss-utils-popover-div-inner-divider'>
                            <Divider>
                                <span className='ss-utils-popover-div-inner-divider-span'>
                                    {header}
                                </span>
                            </Divider>
                        </div>
                        <div className='ss-utils-popover-div-inner-content'>
                            {children}
                        </div>
                    </div>
                )}>

                    <span className='ss-utils-popover-child-div-span'>
                        <Icon type='exclamation-circle-o' style={{...iconStyle, marginLeft: '3px' }} />
                        {noTitle ? null : title}
                    </span>
            </Popover>

    );
    }
}
